import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';
import { memo } from 'react';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '25rem',
        maxWidth: '30rem',
      },
}));

interface ErrorModalProps {
  open: boolean;
  onClose: (open: boolean) => void;
  message?: string;
}

const ErrorModalComponent = ({
  open,
  onClose,
  message = 'Stato civile del soggetto incongruente con la registrazione di matrimonio',
}: ErrorModalProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      fullScreen={fullScreen}
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrand" color="white">
        Attenzione!
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>{message}</DialogContent>
      <DialogActions>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ErrorModalComponent.displayName = 'Modal error';

const ErrorModal = memo(ErrorModalComponent);

export default ErrorModal;
